var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 241,
    viewBox: "0 0 200 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M139.67 49.25C134.202 49.2421 128.96 47.0657 125.095 43.1982C121.229 39.3308 119.055 34.0881 119.05 28.62V0H26.91C19.773 0 12.9284 2.83511 7.88177 7.88171C2.83517 12.9283 0 19.7731 0 26.91V189.13C0.0105984 196.26 2.85042 203.094 7.89587 208.132C12.9413 213.17 19.7799 216 26.91 216H137.52C144.65 216 151.489 213.17 156.534 208.132C161.58 203.094 164.419 196.26 164.43 189.13V49.25H139.67Z",
    fill: "#462B01"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.43 49.25H139.67C134.202 49.2421 128.96 47.0657 125.094 43.1982C121.229 39.3308 119.055 34.0881 119.05 28.62V0L164.43 49.25Z",
    fill: "#462B01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.94 170.61H58.8998C50.0301 170.61 42.8398 177.8 42.8398 186.67V223.95C42.8398 232.82 50.0301 240.01 58.8998 240.01H183.94C192.81 240.01 200 232.82 200 223.95V186.67C200 177.8 192.81 170.61 183.94 170.61Z",
    fill: "#462B01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3498 213.38V220.65H84.8198V213.38H92.3498Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.66 214.78H116.93V220.65H95.5801V215.12L108.64 196.41H95.7501V190.58H116.85V196.11L103.66 214.78Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.67 190.58V220.65H121.43V190.58H128.67Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.96 210.1V220.65H133.69V190.58H145.43C149 190.58 151.73 191.46 153.6 193.24C154.547 194.168 155.287 195.285 155.771 196.519C156.255 197.753 156.473 199.076 156.41 200.4C156.441 202.149 156.006 203.875 155.15 205.4C154.277 206.891 152.983 208.092 151.43 208.85C149.556 209.731 147.5 210.159 145.43 210.1H140.96ZM149.04 200.4C149.04 197.767 147.58 196.433 144.66 196.4H140.96V204.22H144.66C147.58 204.253 149.04 202.98 149.04 200.4Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2 152.52C78.837 152.515 75.6133 151.176 73.2362 148.797C70.8591 146.418 69.5227 143.193 69.52 139.83V127.14H94.89V139.83C94.8874 143.195 93.5495 146.421 91.1702 148.8C88.791 151.18 85.5648 152.517 82.2 152.52ZM76.01 133.63V139.83C76.01 141.473 76.6618 143.048 77.8224 144.211C78.983 145.373 80.5574 146.027 82.2 146.03C83.8435 146.027 85.419 145.373 86.5811 144.211C87.7433 143.049 88.3973 141.473 88.4 139.83V133.63H76.01Z",
    fill: "#462B01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.51 127.15H82.23V114.43H69.51V127.15Z",
    fill: "#462B01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2 114.44H94.9199V101.72H82.2V114.44Z",
    fill: "#462B01"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M69.51 101.73H82.23V89.01H69.51V101.73Z",
    fill: "#462B01"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2 89.02H94.9199V76.3H82.2V89.02Z",
    fill: "#462B01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/ZIP.fc6f9a24a586da39709498c79baf8890.svg";
export { ForwardRef as ReactComponent };